export const ChargeOnCompanyMappingConstant = {
    Table: {
        PRIORITY: "Priority",
        CHARGE_TYPE: "Charge Type",
        SUB_CHARGE_TYPE: "Sub Charge Type",
        SOA: "SOA",
        OPS_LINE: "Ops Line",
        FORWARDER_CODE: "Forwarder/Shipper/Consignee",
        FORWARDER_REF: "Forwarder Ref",
        VESSEL_TYPE: "Vessel Type",
        CHARGE_CODE: "Physical Handling Code",
        OPERATING_TML: "Operating Tml",
        CONSORTIUM: "Consortium",
        SERVICE: "Service",
        CONTAINER_STATUS: "Container Status",
        CHARGEON_COMPANY: "Charge-On Company",
        ACTIVE_IND: "Active Ind.",
    },
    Title: {
        CATEGORY: "Charge",
        TITLE: "Charge-On Company Setting",
        MAPPING_FROM: "From",
        MAPPING_TO: "To",
    }
}
export const chargeOnCompanyMappingRequiredFieldList: string[] = [
    'chargeOnCompanyCode',
    'activeInd',
];